export function defaultTrackerBoutique(user,locations){
 const valid=code=>locations.some(location=>location.code===code);
 if(user?.role==='boutique_manager')return valid(user.boutique_code)?user.boutique_code:'';
 if(user?.user_id){try{const remembered=localStorage.getItem(`toto-performance-boutique:${user.user_id}`);if(valid(remembered))return remembered;}catch{}}
 return [user?.boutique_code,user?.home_boutique_code,user?.employee_profile?.boutique_code].find(valid)||'';
}
